import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import * as S from './styled';
import CardHeader from '../cards/CardHeader';
import ReusableButton from '../../../../../../reusables/Button';
import ReusableCard from '../../../../../../reusables/Card';
import ReusableList from '../../../../../../reusables/List';
import ReusableTitle from '../../../../../../reusables/Title';
import ErrorMessage from '../dialogs/ErrorMessage';
import YouNotHavePhoto from '../dialogs/YouNotHavePhoto';
import Spinner from '@/presentation/components/Spinner';
import routes from '@/presentation/components/Routes/routingMap';
import Link from '@/presentation/reusables/Link';
import MyModal from '@/presentation/modules/procedures/components/Modals/MyModal';
import ErrorMessageData from '@/presentation/components/Error';

export const GoToPhotoComponent = ({ url }: any) => (
  <ul style={{ listStyleType: 'disc', paddingLeft: 16, marginTop: 4 }}>
    <li>
      Tener registrada o actualizada tu foto. Recuerda que la vestimenta debe
      ser formal: en el caso de las mujeres se requiere el uso de blusa y
      sastre; y en el caso de los varones, camisa, corbata y saco.
    </li>
    <li>
      Si aún no has registrado tu foto, regístrala accediendo al trámite{' '}
      <Link
        linkType="internal"
        url={url}
        linkName="actualización de fotografía."
      />
    </li>
  </ul>
);

interface IProps {
  data: any;
  isLoading: boolean;
  hasError?: any;
}

const Component = ({ data, isLoading, hasError }: IProps) => {
  const history = useHistory().push;
  const paramCoverLetter = 'TA0047';

  const goToPhotoUrl = `${routes.student.procedures.categories.requests.updatephoto.procedureinfo}`;

  const [error, setError] = useState({
    title: '',
    description: ''
  });

  const [activeErrorMessage, setActiveErrorMessage] = useState<boolean>(false);
  const [youNotHavePhoto, setYouNotHavePhoto] = useState<boolean>(false);
  const [modalRememberFormalPhoto, setModalRememberFormalPhoto] =
    useState<boolean>(false);

  const controllerReset = () => {
    setModalRememberFormalPhoto(false);
    setActiveErrorMessage(false);
    setYouNotHavePhoto(false);
    setError({ title: '', description: '' });
  };

  const controllerDownload = () => {
    const a = document.createElement('a');
    a.target = '_blank';
    a.href = `../../../assets/documents/${data?.model}`;
    a.download = 'modelo-de-certificado.pdf';
    a.click();
    a.remove();
  };

  const controllerNext = () => {
    if (data?.error) {
      setError({
        title: data?.error?.title ?? '¡Oh no!',
        description: data?.error?.description ?? 'Ocurrió un error inesperado.'
      });
      setActiveErrorMessage(true);
    } else if (!data?.hasPhoto) {
      setYouNotHavePhoto(true);
    } else {
      setModalRememberFormalPhoto(true);
    }
  };

  if (hasError) {
    return <ErrorMessageData />;
  }

  return (
    <S.Container>
      {isLoading ? (
        <Spinner />
      ) : (
        <>
          <CardHeader data={data} />
          <ReusableCard
            style={{ marginTop: '24px' }}
            padding="16px 16px 16px 16px"
          >
            <ReusableTitle
              fontSize="14px"
              fontWeight="700"
              lineHeight="20px"
              title="Requisitos necesarios"
            />
            <GoToPhotoComponent
              url={`${routes.student.procedures.categories.requests.updatephoto.procedureinfo}`}
            />
            <ReusableButton
              iconAppend="arrow-right"
              outlined
              style={{ marginTop: '16px' }}
              text="Ver modelo"
              onClick={() => controllerDownload()}
            />
          </ReusableCard>
          <ReusableCard style={{ marginTop: '12px' }} padding="16px">
            <ReusableTitle
              fontSize="14px"
              fontWeight="700"
              lineHeight="20px"
              title="Consideraciones"
            />
            Los ciclos con deudas no estarán habilitados para solicitar el
            certificado. <br />
            Si tienes algún pago pendiente, puedes regularizarlo en la{' '}
            <Link
              linkType="internal"
              url={`${routes.student.payments.home}`}
              linkName="sección pagos."
            />
            <br />
            <br />
            Para solicitar un certificado de estudios con convalidaciones
            externas, debes hacerlo por{' '}
            <Link
              linkType="internal"
              url={`${routes.student.procedures.categories.tickets.register}?v=${paramCoverLetter}`}
              linkName="solicitud SAE."
            />
          </ReusableCard>
          <ReusableCard
            style={{ marginTop: '12px' }}
            padding="16px 16px 16px 16px"
          >
            <ReusableTitle
              fontSize="14px"
              fontWeight="700"
              lineHeight="20px"
              title="Pasos a seguir:"
            />
            <ReusableList
              isDecimal
              items={data?.stepsToFollow}
              style={{ marginTop: '12px' }}
            />
          </ReusableCard>

          <ReusableButton
            style={{ marginTop: '40px' }}
            text="Empezar solicitud"
            onClick={() => controllerNext()}
          />

          <ErrorMessage
            data={error}
            show={activeErrorMessage}
            handlerClose={() => controllerReset()}
          />

          <YouNotHavePhoto
            show={youNotHavePhoto}
            goToUrl={goToPhotoUrl}
            handlerClose={() => controllerReset()}
          />

          <MyModal
            data={{
              title: 'Recuerda tener vestimenta formal en tu foto',
              description: (
                <>
                  Para las mujeres, se requiere el uso de blusa y sastre. Y en
                  el caso de los varones es camisa, corbata y saco. Si no
                  cumples con el requisito,{' '}
                  <Link
                    linkType="internal"
                    url={goToPhotoUrl}
                    linkName="actualiza tu fotografía."
                  />
                </>
              )
            }}
            show={modalRememberFormalPhoto}
            handlerClose={() => controllerReset()}
            handlerClick={() => {
              controllerReset();
              history(
                `${routes.student.procedures.categories.requests.certificateOfStudies.procedureregister}`
              );
            }}
          />
        </>
      )}
    </S.Container>
  );
};

export default Component;
